export const frontmatter = {
    "draft": false,
    "title": "Guía: Plantillas",
    "description": "Cómo crear y gestionar plantillas de WhatsApp en OnnIA: componentes, variables dinámicas, estados de aprobación y recomendaciones.",
    "sidebar_label": "Plantillas",
    "sidebar_group": "referencia",
    "sidebar_order": 6
}

export const toc = [
    {
        "depth": 2,
        "id": "acceso-al-modulo",
        "value": "Acceso al módulo"
    },
    {
        "depth": 2,
        "id": "crear-una-plantilla",
        "value": "Crear una plantilla"
    },
    {
        "depth": 3,
        "id": "datos-generales-y-configuracion-de-envio",
        "value": "Datos generales y configuración de envío"
    },
    {
        "depth": 3,
        "id": "componentes-blocks",
        "value": "Componentes (Blocks)"
    },
    {
        "depth": 2,
        "id": "estados-de-la-plantilla",
        "value": "Estados de la plantilla"
    },
    {
        "depth": 2,
        "id": "recomendaciones",
        "value": "Recomendaciones"
    }
]